import React, { useEffect, useState } from "react";
import ReportTablePage from "./ReportTablePage";
import { getCashierSummaryReport } from "../../services/api";

export default function CashierReportPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
  });

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    try {
      setLoading(true);
      const res = await getCashierSummaryReport(filters);
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setFilters({
      dateFrom: "",
      dateTo: "",
    });
  };

  const formatMoney = (value) =>
    Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const columns = [
    { label: "Cashier Signature", key: "cashier_name" },
    { label: "Transactions", key: "txn_count" },
    {
      label: "Total Amount",
      key: "total_amount",
      render: (row) => `TSH ${formatMoney(row.total_amount)}`,
      exportValue: (row) => `TSH ${formatMoney(row.total_amount)}`,
    },
  ];

  const filterNodes = (
    <>
      <div>
        <label className="field-label">Date From</label>
        <input
          type="date"
          className="input"
          value={filters.dateFrom}
          onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
        />
      </div>

      <div>
        <label className="field-label">Date To</label>
        <input
          type="date"
          className="input"
          value={filters.dateTo}
          onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
        />
      </div>
    </>
  );

  return (
    <ReportTablePage
      title="Cashier Report"
    //   subtitle="Transactions grouped by cashier signature"
      filters={filterNodes}
      rows={rows}
      columns={columns}
      loading={loading}
      onSearch={loadReport}
      onClear={clearFilters}
      exportFileName="cashier_report.csv"
    />
  );
}